<form [formGroup]="formName">
    <div class="relative">
    <p-inputNumber pKeyFilter="num" [formControlName]="field?.isOneToMultiple ? field?.attributeCodeOneToMultiple : field.attributeCode" [showButtons]="true" class="w-full"> </p-inputNumber>
    <span class="unit right">{{ unit}}</span>

</div>
</form>